import { SvgFitWeddingText, SvgWordBox } from "assets";
import { SelectBox } from "components/SelectBox";
import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userSelectFittableHall } from "recoil/atoms";
import { fetcher } from "utils/ApiUtil";
import styles from "./style.module.css";

enum pageSet {
  firstPage,
  wantLocation,
  wantWeddingHallType,
  wantConcurrent,
  wantMenu,
  wantPeriod,
  expectCount,
}

export interface ILocation {
  location_1: string;
  location_2: string[];
}
export interface IListData {
  no: string;
  type: string;
  content: string;
  ordering: number;
  del_yn: "Y" | "N";
  createdAt: string;
  updatedAt: string;
}

interface ICommon {
  title: string;
  list: IListData[];
}

export interface IFillterData {
  hall_type: ICommon;
  single_hall: ICommon;
  hall_style: ICommon;
  inside: ICommon;
  hall_term: ICommon;
  max_headcount: ICommon;
  min_headcount: ICommon;
  meal_type: ICommon;
  mood: ICommon;
}

export interface IListDataContent {
  content: string;
  createdAt?: string;
  del_yn?: "Y" | "N";
  no: string[] | string;
  ordering: number;
  type: string;
  updatedAt?: string;
}

export default function RecommendWeddingHall() {
  const [page, setPage] = useState(0);
  const [userSelectData, setUserSelectData] = useRecoilState(
    userSelectFittableHall
  );
  const [location, setLocation] = useState<ILocation[]>();
  const [weddingHallType, setWeddingHallType] = useState<IListDataContent[]>();
  const [singleHall, setSingleHall] = useState<IListDataContent[]>();
  const [hallStyle, setHallStyle] = useState<IListDataContent[]>();
  const [inside, setlnside] = useState<IListDataContent[]>();
  const [hallTerm, setHallTerm] = useState<IListDataContent[]>();
  const [minHeadcount, setMinHeadcount] = useState<IListDataContent[]>();
  const [mealType, setMealType] = useState<IListDataContent[]>();

  const getLocation = async () => {
    const { data } = await fetcher("/api/contructor/getLocation");
    setLocation(data.result);
  };

  const getHallFillterList = async () => {
    const { data } = await fetcher<IFillterData>(
      "/api/contructor/getHallFilterList"
    );
    setWeddingHallType(data.hall_type.list);
    setSingleHall(data.single_hall.list);
    setlnside(data.single_hall.list);
    setHallStyle(data.hall_style.list);
    setHallTerm(data.hall_term.list);
    setMinHeadcount(data.min_headcount.list);
    setMealType(data.meal_type.list);
  };

  useEffect(() => {
    getLocation();
    getHallFillterList();
  }, []);
  const containerRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    const containerNode = containerRef.current;
    containerNode?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [page]);

  return (
    <div
      style={{
        backgroundImage: `url("/images/backgroundPic.png")`,
        backgroundSize: "cover",
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className={styles.container} ref={containerRef}>
        {(() => {
          switch (page) {
            case pageSet.firstPage:
              return (
                <div
                  style={{
                    height: "70vh",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <div className={styles.textCenter}>
                    <SvgWordBox />
                    <div
                      style={{
                        marginTop: "30px",
                      }}
                    >
                      <SvgFitWeddingText />
                    </div>

                    <div className={styles.textDiv}>
                      나에게 딱 맞는 웨딩홀! 찾기 어려우신 <br /> 신부님들을
                      위해 메이크마이웨딩이함께합니다
                    </div>
                  </div>
                  <div
                    className={styles.startButton}
                    onClick={() => setPage(1)}
                  >
                    START
                  </div>
                </div>
              );
            case pageSet.wantLocation:
              return (
                <SelectBox
                  title={`원하는 지역을 \n 선택해주세요.`}
                  subTitle="중복 선택 가능"
                  localList={location}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.wantLocation}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      wantLocation: value,
                    }))
                  }
                  column={2}
                  selectType="multi"
                />
              );
            case pageSet.wantWeddingHallType:
              return (
                <SelectBox
                  title={`원하는 웨딩홀 타입을 \n 선택해주세요.`}
                  subTitle="중복 선택 가능"
                  filterList={weddingHallType}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.wantWeddingHallType}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      wantWeddingHallType: value,
                    }))
                  }
                  column={2}
                  selectType="multi"
                />
              );

            case pageSet.wantConcurrent:
              return (
                <SelectBox
                  title={`동시예식, 분리예식 \n 어느 것을 더 선호하시나요?`}
                  subTitle="중복 선택 가능"
                  filterList={hallStyle}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.wantConcurrent}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      wantConcurrent: value,
                    }))
                  }
                  column={3}
                  desc={`<p><strong>동시예식이란?</strong> <br/>  예식과 식사가 같은 장소에서 동시에 진행되는  것을 의미합니다. 1부 예식 후 식사가 시작되며 2부 예식을 식사와 함께 즐기실 수 있습니다.</p>
                  <p style='margin-top:8px'><strong>분리예식이란?</strong> <br/>예식과 식사가 분리되어 진행되는 예식을 의미합니다. 예식 후, 피로연장에서 식사가 진행됩니다.</p>`}
                  selectType="multi"
                />
              );
            case pageSet.wantMenu:
              return (
                <SelectBox
                  title={`원하시는 식사 메뉴를 \n 선택해주세요`}
                  subTitle="중복 선택 가능"
                  filterList={mealType}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.wantMenu}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      wantMenu: value,
                    }))
                  }
                  column={2}
                  selectType="multi"
                />
              );
            case pageSet.wantPeriod:
              return (
                <SelectBox
                  title={`원하시는 식 간격을 \n 선택해주세요`}
                  subTitle="중복 선택 가능"
                  filterList={hallTerm}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.wantPeriod}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      wantPeriod: value,
                    }))
                  }
                  column={2}
                  selectType="multi"
                />
              );
            case pageSet.expectCount:
              return (
                <SelectBox
                  title={`예상 하객 수를 \n 선택해주세요`}
                  subTitle="(단, 보증인원의 경우 예식 시간, 시기에 따라 상이한 점 참고부탁드립니다)"
                  filterList={minHeadcount}
                  page={page}
                  setPage={(page: number) => setPage(page)}
                  selectedValue={userSelectData.expectCount}
                  setValue={(value) =>
                    setUserSelectData((state) => ({
                      ...state,
                      expectCount: value,
                    }))
                  }
                  column={2}
                  selectType="single"
                />
              );
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
}
